/**
 * @component Else
 * @since 1.0.0
 */
export function Else(props) {
    return props.children || null;
}
